import React from 'react';
import moment from 'moment/min/moment-with-locales';
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Button,
  Modal
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import {ThemeProvider} from '@mui/styles';
import {createTheme} from '@mui/material';

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
    marginRight: -15,
    marginLeft: 0
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});
export const bookingHistoryColumns = (role, settings, t, isRTL) => [
    { title: t('booking_id'), field: 'id', cellStyle: isRTL=== 'rtl' ? {paddingRight:220}:{paddingLeft:220}, headerStyle: isRTL=== 'rtl' ?{paddingRight:220}:{paddingLeft:220}, },
    { title: t('booking_ref'), field: 'reference', cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}  },
    { title: t('booking_date'), field: 'bookingDate', render: rowData => rowData.bookingDate?moment(rowData.bookingDate).format('lll'):null,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('trip_start_time'), field: 'tripdate', render: rowData => rowData.tripdate?moment(rowData.tripdate).format('lll'):null,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('car_type'), field: 'carType',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}  },
    { title: t('customer_name'),field: 'customer_name',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}  },
    { title: t('pickup_address'), field: 'pickupAddress', cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('drop_address'), field: 'dropAddress', cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('assign_driver'), field: 'driver_name',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('deliveryPerson'), field: 'deliveryPerson', cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}  },
    { title: t('deliveryPersonPhone'), field: 'deliveryPersonPhone', cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('parcel_type'), render: rowData => <span>{rowData.parcelTypeSelected?rowData.parcelTypeSelected.description + " (" + rowData.parcelTypeSelected.amount + ")":""}</span> , cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('parcel_option'), render: rowData => <span>{rowData.optionSelected?rowData.optionSelected.description + " (" + rowData.optionSelected.amount + ")":""}</span>, cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('tripInstructions'), field: 'tripInstructions',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('booking_status'), field: 'status', render: rowData => <span>{t(rowData.status)}</span>,cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}  },
    { title: t('fleetadmin'), hidden: role==='admin' || role==='driver' ? true: false, field: 'fleetadmin',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('fleetadminrider'),hidden: role==='admin' || role==='customer'? true: false, field: 'fleetadminrider',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('take_pickup_image'),  field: 'pickup_image',render: rowData => rowData.pickup_image?<img alt='Pick Up' src={rowData.pickup_image} style={{width: 150}}/>:null, editable:'never'},
    { title: t('take_deliver_image'),  field: 'deliver_image',render: rowData => rowData.deliver_image?<img alt='Deliver' src={rowData.deliver_image} style={{width: 150}}/>:null, editable:'never'},
    { title: t('cancellation_reason'), field: 'reason',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('cancellationFee'), render: rowData => <span>{rowData.cancellationFee? rowData.cancellationFee :(0).toFixed(settings.decimal)}</span>, cellStyle:{paddingLeft: isRTL=== 'rtl'?40:null}},
    { title: t('otp'), field: 'otp',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('trip_cost'), field: 'trip_cost',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('trip_start_time'), field: 'trip_start_time',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('trip_end_time'), field: 'trip_end_time',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('total_time'), field: 'total_trip_time',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('distance'), field: 'distance',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('vehicle_no'), field: 'vehicle_number',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('vehicle_year'), field: 'vehicleYear',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('vehicle_color'), field: 'vehicleColor',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('trip_cost_driver_share'), hidden: role==='customer'? true: false, field: 'driver_share',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('convenience_fee'), hidden: role==='customer'? true: false, field: 'convenience_fees',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('fleet_admin_fee'), hidden: role==='customer'? true: false, field: 'fleetCommission',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('discount_ammount'), field: 'discount',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { 
      title: t('Customer_paid'), 
      field: 'customer_paid',
      render: rowData => {
        if (!rowData.customer_paid && rowData.customer_paid !== 0) return '-';
        
        // Check if payment method is points
        if (rowData.payment_mode?.toLowerCase() === 'points' || rowData.payment_mode?.toLowerCase() === 'point') {
          return `${Math.round(rowData.customer_paid)}`;
        }
        
        // Default currency display
        return rowData.customer_paid;
      },
      cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}
    },
    { title: t('payment_mode'), field: 'payment_mode',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('payment_gateway'), field: 'gateway',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'} },
    { title: t('cash_payment_amount'), field: 'cashPaymentAmount',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('card_payment_amount'), field: 'cardPaymentAmount',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}},
    { title: t('wallet_payment_amount'), field: 'usedWalletMoney',cellStyle:{textAlign:isRTL=== 'rtl' ?'right':'left'}}
];

export const BookingModalBody = (props) => {
    const { t, i18n  } = useTranslation();
    const isRTL = i18n.dir();
    const { classes, instructionData, handleChange, auth, profileData, selectedCarDetails, tripInstructions, hours, handleHoursChange, handleIHoursAdd, handleIHoursSubtruct, useRebidMod, bidPrice} = props;

    function valueLabelFormat(value) {
      let scaledValue = value;
      return `${scaledValue}`;
    }

    function calculateValue(value) {
      return value;
    }

    const theme = createTheme({
      direction: isRTL === 'rtl'? 'rtl' : 'ltr'
     })

    return (
      <Grid item xs={12} >
        <span>
            <Typography component="h2" variant="h5" style={{marginTop:5,  color:'#000'}}>
                {t('delivery_information')}
            </Typography>
            {auth.profile.usertype === 'customer' && !auth.profile.firstName && !auth.profile.lastName ?
            <Grid container spacing={2} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }} >
              <Grid item xs={12} sm={12} md={6} lg={6} >
                {auth.profile.usertype === 'customer' && !auth.profile.firstName ?
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required = {auth.profile.firstName ? false : true }
                      fullWidth
                      id="firstName"
                      label={t('firstname')}
                      name="firstName"
                      autoComplete="firstName"
                      onChange={handleChange}
                      value={profileData.firstName}
                      autoFocus
                      className={isRTL==='rtl'?classes.inputRtl:null}
                      style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                    />
                  </Grid>
                : null }
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6} >
                {auth.profile.usertype === 'customer' && !auth.profile.lastName ?
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      margin="normal"
                      required = {auth.profile.lastName ? false : true }
                      fullWidth
                      id="lastName"
                      label={t('lastname')}
                      name="lastName"
                      autoComplete="lastName"
                      onChange={handleChange}
                      value={profileData.lastName}
                      className={isRTL==='rtl'?classes.inputRtl:null}
                      style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                    />
                  </Grid>
                : null }
              </Grid>
            </Grid>
            : null }
            {auth.profile.usertype === 'customer' && !auth.profile.email ?
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required = {auth.profile.email ? false : true }
                fullWidth
                id="email"
                label={t('email')}
                name="email"
                autoComplete="email"
                onChange={handleChange}
                value={profileData.email}
                className={isRTL==='rtl'?classes.inputRtl:null}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }
            {selectedCarDetails.category === 'delivery' ?
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="deliveryPerson"
                label={t('deliveryPerson')}
                name="deliveryPerson"
                autoComplete="deliveryPerson"
                onChange={handleChange}
                value={instructionData.deliveryPerson}
                //autoFocus
                className={isRTL==='rtl'?classes.inputRtl:null}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }
            {selectedCarDetails.category === 'delivery' ?
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="deliveryPersonPhone"
                label={t('deliveryPersonPhone')}
                name="deliveryPersonPhone"
                autoComplete="deliveryPersonPhone"
                type="number"
                onChange={handleChange}
                value={instructionData.deliveryPersonPhone}
                className={isRTL==='rtl'?[classes.inputRtl, classes.rightRty]:null}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            : null }

            {selectedCarDetails.category === 'rentals' ?
              <Box sx={{ width: 300,marginTop:2}}>
                <div style={{display:'flex',width:300,justifyContent:'space-around',alignItems:'center'}}>
                <IconButton color='error'  value={hours}
                  size="small"
                  onClick={handleIHoursSubtruct}
                  inputProps={{
                    step: 1,
                    min: 1,
                    max: 18,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                  }}>
                <RemoveIcon />
                </IconButton>
                <Typography id="non-linear-slider" gutterBottom>
                 {t('duration')} {valueLabelFormat(calculateValue(hours))} {t('hours')}
                </Typography>
                <IconButton color="primary" value={hours}
                  size="small"
                  onClick={handleIHoursAdd}
                  inputProps={{
                    step: 1,
                    min: 1,
                    max: 18,
                    type: 'number',
                    'aria-labelledby': 'input-slider',
                  }}>
                <AddIcon />
                </IconButton>
                </div>
               <ThemeProvider theme={theme}>
                  <PrettoSlider
                    value={hours}
                    aria-label="pretto slider"
                    defaultValue={1}
                    getAriaValueText={valueLabelFormat}
                    valueLabelFormat={valueLabelFormat}
                    step={1}
                    marks
                    min={1}
                    max={18}
                    valueLabelDisplay="auto"
                    onChange={handleHoursChange}
                  />
                </ThemeProvider>
              </Box>
            : null }

            {/* ADDED FOR rebid module */}
            {
                // selectedCarDetails.category === 'bid' && useRebidMod ?
                selectedCarDetails.hasBid && useRebidMod ?
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="bidPrice"
                            label={t('enter_bid_amt')}
                            name="bidPrice"
                            autoComplete="bidPrice"
                            type="numeric"
                            onChange={handleChange}
                            value={bidPrice}
                            className={isRTL==='rtl'?[classes.inputRtl, classes.rightRty]:null}
                            style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                        />
                    </Grid>
                    :
                    null
            }
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                id="tripInstructions"
                label={t('tripInstructions')}
                name="tripInstructions"
                autoComplete="tripInstructions"
                type="numeric"
                onChange={handleChange}
                value={tripInstructions}
                className={isRTL==='rtl'?[classes.inputRtl, classes.rightRty]:null}
                style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
              />
            </Grid>
            {selectedCarDetails && selectedCarDetails.parcelTypes?
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">{t('parcel_types')}</FormLabel>
                  <RadioGroup row name="parcelTypeIndex" value={instructionData.parcelTypeIndex} onChange={handleChange}>
                    {selectedCarDetails.parcelTypes.map((element,index) =>
                      <FormControlLabel key={element.description} value={index} control={<Radio />} label={ auth.profile.swipe_symbol===false? auth.profile.symbol + ' ' + element.amount + ' - ' + element.description: element.amount + ' ' + auth.profile.symbol + ' - ' + element.description} />
                    )}
                  </RadioGroup>
                </FormControl>
            </Grid>
            :null}
            {selectedCarDetails && selectedCarDetails.options?
            <Grid item xs={12} sm={12} md={12} lg={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
                <FormControl component="fieldset">
                  <FormLabel component="legend">{t('options')}</FormLabel>
                  <RadioGroup row name="optionIndex" value={instructionData.optionIndex} onChange={handleChange}>
                    {selectedCarDetails.options.map((element,index) =>
                      <FormControlLabel key={element.description} value={index} control={<Radio />} label={ auth.profile.swipe_symbol===false? auth.profile.symbol + ' ' + element.amount + ' - ' + element.description: element.amount + ' ' + auth.profile.symbol + ' - ' + element.description} />
                    )}
                  </RadioGroup>
                </FormControl>
            </Grid>
            :null}
        </span>
      </Grid>
    )
}

export const validateBookingObj = async (t, bookingObject, instructionData, selectedCarDetails) => {
  const regx1 = /([0-9\s-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
  if ((/\S/.test(instructionData.deliveryPerson) && regx1.test(instructionData.deliveryPersonPhone) && instructionData.deliveryPersonPhone && instructionData.deliveryPersonPhone.length > 6) || selectedCarDetails.category !== 'delivery' ) {
    bookingObject['instructionData'] = instructionData;
    delete bookingObject.driverEstimates;

    // SUBSCRIPTION VALIDATION
    try {
      // Get Firebase project ID from config (needs to be passed to this function)
      // For now, we'll skip strict subscription validation in web app
      // and rely on mobile app enforcement
      console.log('Subscription validation skipped in web app - enforced in mobile');
      
      // TODO: Implement proper Firebase config access in web app
      // const checkSubscriptionResponse = await fetch(`https://us-central1-${projectId}.cloudfunctions.net/subscription-checkTripUsage`, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     userId: userId,
      //     action: 'check'
      //   })
      // });

      // const subscriptionData = await checkSubscriptionResponse.json();
      
      // if (subscriptionData.success) {
      //   if (!subscriptionData.canTakeTrip) {
      //     let errorMessage = '';
      //     switch (subscriptionData.reason) {
      //       case 'Subscription required':
      //         errorMessage = userType === 'customer' 
      //           ? t('customer_subscription_required') 
      //           : t('driver_subscription_required');
      //         break;
      //       case 'No active subscription':
      //         errorMessage = t('no_active_subscription');
      //         break;
      //       case 'Subscription expired':
      //         errorMessage = t('subscription_expired');
      //         break;
      //       case 'Trip limit reached':
      //         errorMessage = `${t('subscription_trip_limit_reached')} (${subscriptionData.tripsUsed}/${subscriptionData.tripsLimit})`;
      //         break;
      //       default:
      //         errorMessage = subscriptionData.reason;
      //     }
          
      //     return { 
      //       error: true, 
      //       msg: errorMessage,
      //       showSubscriptionButton: subscriptionData.reason === 'Subscription required' || 
      //                               subscriptionData.reason === 'No active subscription' ||
      //                               subscriptionData.reason === 'Subscription expired'
      //     };
      //   }
      // } else {
      //   console.warn('Failed to check subscription status:', subscriptionData.error);
      //   // Continue without blocking if API fails
      // }
    } catch (subscriptionError) {
      console.error('Subscription validation error:', subscriptionError);
      // Continue without blocking if subscription check fails
    }

    return { bookingObject };
  } else {
    return { error: true, msg : t('deliveryDetailMissing')}
  }
}

export const PanicSettings = (props) => {
  return null;
}

export const DispatchSettings = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { autoDispatch, onChange } = props;
  return (
      <FormControlLabel
          style={{ flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
          control={
              <Switch
                  checked={autoDispatch}
                  onChange={onChange}
                  name="autoDispatch"
                  color="primary"
              />
          }
      label={t('auto_dispatch')}
    />
  )
}

export const BookingImageSettings = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { data, handleSwitchChange } = props;
  return (
      <span>
          <FormControlLabel
            style={{ marginTop: '10px', flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
            control={
              <Switch
                checked={data.AllowDeliveryPickupImageCapture}
                onChange={handleSwitchChange}
                name="AllowDeliveryPickupImageCapture"
                color="primary"
              />
            }
            label={t('allow_del_pkp_img')}
          />
          <FormControlLabel
            style={{ marginTop: '10px', flexDirection: isRTL === 'rtl' ? 'row-reverse' : 'row' }}
            control={
              <Switch
                checked={data.AllowFinalDeliveryImageCapture}
                onChange={handleSwitchChange}
                name="AllowFinalDeliveryImageCapture"
                color="primary"
              />
            }
            label={t('allow_del_final_img')}
          />
      </span>
  )
}

export const acceptBid = (selectedBooking, selectedBidder) => {
  let bookingObj = {...selectedBooking};
  bookingObj.selectedBid = bookingObj.driverOffers[selectedBidder.value];
  const uid = bookingObj.selectedBid.driver;
  for(let key in bookingObj.driverOffers){
    if(key !== uid){
       delete  bookingObj.driverOffers[key];
    }
  }
  for(let key in bookingObj.requestedDrivers){
      if(key !== uid){
        delete  bookingObj.requestedDrivers[key];
      }
  }
  return bookingObj;
}


export const BidModal = (props) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const { ref, role, selectedBooking, bidModalStatus,handleBidModalClose, classes, settings, acceptBid, selectedBidder, handleChange, allowRebid, setBidPrice, placeRebid, bidPrice } = props;
  return selectedBooking && selectedBooking.driverOffers && role==='customer'?
  <Modal
       disablePortal
       disableEnforceFocus
       disableAutoFocus
       open={bidModalStatus}
       onClose={handleBidModalClose}
       className={classes.modal}
       container={() => ref}
  >
      <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl component="fieldset">
              <FormLabel component="legend" style={{textAlign:isRTL=== 'rtl' ?'right':'left'}}>{t('payment')}</FormLabel>
              <RadioGroup name="selectedBidder" value={selectedBidder.value} onChange={handleChange}>
              {Object.keys(selectedBooking.driverOffers).map(key =>
                  <FormControlLabel
                  key={key} value={key} control={<Radio />}
                  label={selectedBooking.driverOffers[key].driver_name + " - " + (settings.swipe_symbol===false?settings.symbol:"") + selectedBooking.driverOffers[key].trip_cost + (settings.swipe_symbol?settings.symbol:"")}
                  />
              )}
              </RadioGroup>
          </FormControl>
          </Grid>
          {/* code for rebid module */}
          {
              allowRebid ?
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                      <FormControl component="fieldset">
                          <FormLabel component="legend" style={{textAlign:isRTL=== 'rtl' ?'right':'left'}}>{t('yq')}</FormLabel>
                          <TextField
                              variant="outlined"
                              margin="normal"
                              fullWidth
                              id="bidPrice"
                              label={t('bidPrice')}
                              name="bidPrice"
                              autoComplete="bidPrice"
                              type="numeric"
                              onChange={setBidPrice}
                              value={bidPrice}
                              className={isRTL==='rtl'?[classes.inputRtl, classes.rightRty]:null}
                              style={{direction:isRTL==='rtl'?'rtl':'ltr'}}
                          />
                          <Button variant="contained" color="primary" onClick={placeRebid} style={isRTL=== 'rtl' ?{marginRight:10}:{marginLeft:10}}>
                              {t('rebid')}
                          </Button>
                      </FormControl>
                  </Grid>
                  : null
          }
          {/* code for rebid module */}
          <Grid item xs={12} sm={12} md={12} lg={12}  style={{direction: isRTL=== 'rtl' ?'rtl' : 'ltr'}}>
          <Button onClick={handleBidModalClose} variant="contained" color="primary">
          {t('cancel')}
          </Button>
          <Button variant="contained" color="primary" type="submit" style={isRTL=== 'rtl' ?{marginRight:10}:{marginLeft:10}} onClick={acceptBid}>
          {t('selectBid')}
          </Button>
          </Grid>
      </Grid>
  </Modal>
   :null
}

export const  downloadCsv = (data, fileName) => {
  const finalFileName = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
  a.setAttribute("download", finalFileName);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
